import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "nxtconstants";
import { WealthyEnv } from "helpers";

const VisitUs = ({ visitUsData = {} }) => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 700);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);


  if (isMobile === null) return null;

  return (
    <Section>
      <Title>{visitUsData.title}</Title>
      <Subtitle>
        {isMobile
          ? visitUsData.subtitle?.mobile
          : visitUsData.subtitle?.desktop
        }
      </Subtitle>
      <MapCard>
        <InfoBlock>

          <Divider />
          {visitUsData.stats && visitUsData.stats.map((stat, index) => (
            <InfoPair key={index}>
              <InfoTitle>{stat.title}</InfoTitle>
              <InfoSub>{stat.subtitle}</InfoSub>
            </InfoPair>
          ))}
          <ComeVisitHeading>{visitUsData.ctaHeading}</ComeVisitHeading>
          <ButtonSection>
            <CTAButton href="#register">
              {visitUsData.ctaText}
            </CTAButton>
          </ButtonSection>
        </InfoBlock>

        <MapWrapper>
          {isMobile ? (
            <MapImg src={visitUsData.mobImage} alt="Wealthy India Office Locations Map" />
          ) : (
            <>
              <ImageContainer>
                <MapImg
                  src={visitUsData.mapImage}
                  alt="Wealthy India Office Locations Map"
                  $width={visitUsData.mapImageWidth}
                  $padding={visitUsData.mapImagePadding}
                />
              </ImageContainer>
            </>
          )}
        </MapWrapper>

      </MapCard>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  margin: 0 auto;
  margin-top: 10rem;

  @media (max-width: 768px) {
    margin: 5.6rem 0;
  }
`;

const Title = styled.h2`
  font-family: 'DM Serif Display';
  color: ${colors.textBlack};
  font-size: 5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 2.7rem;
    font-size: 2.7rem;
    margin: 0px;
  }
`;

const Subtitle = styled.p`
  font-size: 2rem;
  font-family: 'Lato';
  font-weight: 400;
  color: ${colors.textGray};
  text-align: center;
  width: 70%;
  margin: 0 auto 6rem auto;
  line-height: 3.2rem;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    width: 80%;
    line-height: 2.3rem;
    margin-bottom: 2rem;

  }
`;

const MapCard = styled.div`
  background: ${colors.textBlack};
  border-radius: 3.6rem;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  min-height: 35rem;
  display: flex;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    border-radius: 2.7rem;
    width: 85%;
    margin: 0 auto;
    min-height: unset;
    padding-bottom: 5rem;
  }
`;

const MapWrapper = styled.div`
  flex: 2;
  position: relative;
  min-height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    order:1;
    min-height: 24.5rem;
    width: 100%;
    height: 24.5rem;
    margin-top: 1rem;
  }
`;

const MapImg = styled.img`
  width: ${props => props.$width || "100%"};
  height: auto;
  margin-top: ${props => props.$marginTop || "0"};
  padding: ${props => props.$padding || "0"};
  display: block;
  border-radius: 0 3.6rem 3.6rem 0;
  filter: brightness(0.85);
  position: relative;

  @media (max-width: 768px) {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    border-radius: 0;
    max-width: 100%;
    margin-top: 0;
    padding: 0;
  }
`;


const ImageContainer = styled.div`
  width: 100%;         
  height: 100%;        
  position: relative;  
  max-width: 58rem;    
  margin-left: 2rem;   

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    margin-left: 0;
  }
`;

const InfoBlock = styled.div`
  flex: 1.2;
  padding: 6rem 4rem 6rem 9rem;
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;  
  margin-top: 5rem;
  
  @media (max-width: 768px) {
    order: 2;
    padding: 0px 1.2rem 0 1.2rem;
    margin-top: 0;
    align-items: center;
    text-align: center;
  }
`;

const ComeVisitHeading = styled.h2`
  font-size: 4.2rem;
  font-weight: 400;
  font-family: 'DM Serif Display';
  margin-bottom: 1.6rem;
  color: ${colors.white};

  @media (max-width: 768px) {
    font-size: 2.7rem;
    font-weight: 600;
    margin-bottom: 2.2rem;
  }
`;

const ButtonSection = styled.div`
    width: fit-content;
    text-align: center;
`;

const CTAButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${colors.primary};
  color: white;
  border: none;
  border-radius: 5rem;
  padding: 1rem 4rem;
  font-family: 'Lato';
  font-size: 1.8rem;
  font-weight: 700;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 768px) {
    padding: 1rem 7rem;
    font-size: 1.4rem;
  }
`;

const Divider = styled.div`
  width: 90%;
  height: 1px;
  background: white;
  opacity: 0.2 ;
  margin: 0 auto 3.5rem auto;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const InfoPair = styled.div`
  display: inline-block;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

const InfoTitle = styled.div`
  font-size: 3rem;
  font-family: 'Lato';
  font-weight: 400;
  margin-bottom: 0.5rem;
  line-height: 1.4;
  color: ${colors.white};

  @media (max-width: 768px) {
    font-size: 1.8rem;
    font-weight: 600;
  }
`;

const InfoSub = styled.div`
  font-size: 2rem;
  color: #6F6F6F;
  margin-bottom: 3rem;
  font-weight:400;
  font-family: 'Lato';
  
  @media (max-width: 768px) {
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
  }
`;
export default VisitUs;
